<article class="container_passSii">
  <div class="dialog-header">
    <button mat-icon-button (click)="cerrarDialogo()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <section *ngIf="showSection">
    <form
      action=""
      class="form_pass_SII"
      [formGroup]="form"
      (ngSubmit)="submit()"
    >
      <h2>La contraseña registrada es <span style="color:red">incorrecta</span> !</h2>
      <h3>Cambio de contraseña de SII</h3>
      <section class="container-form">
        <mat-form-field class="example-form-field">
          <mat-label>Contraseña </mat-label>
          <input matInput formControlName="passSII" />
        </mat-form-field>
        <div *ngIf="form.controls['passSII'].errors?.['invalidRut']">
          <ng-container *ngIf="form.controls['passSII'].errors?.['passSII']">
            Contraseña incorrecta
          </ng-container>
        </div>
        <button
          [disabled]="!form.valid"
          mat-stroked-button
          color="primary"
          type="submit"
          class="w-50"
        >
          Guardar
        </button>
      </section>
    </form>
  </section>
  <section class="consultar_PassSii" *ngIf="!showSection">
    <h2>Consultar Contraseña SII</h2>
    <div class="sii_conectado" *ngIf="booleanText == false">
      <h4>{{ data?.isSiiConnected === false ? 'No Conectado' : 'Conectado' }}</h4>
      
      <i-tabler
        [ngStyle]="{
          color:
            data != undefined && data.isSiiConnected === false
              ? 'red'
              : data != undefined && data.isSiiConnected === true
              ? 'mediumspringgreen'
              : 'grey',
            
        }"
        class="icon-20"
        name="circle-filled"
      ></i-tabler>
    </div>
    <div *ngIf="booleanFlag == true" style="margin: 20px 0px">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <button
      mat-stroked-button
      color="primary"
      type="submit"
      class="w-50"
      (click)="validateSii()"
    >
      Validar Contraseña
    </button>
  </section>
</article>
<ng-template #spinner> </ng-template>
